import { uiComponentsLocalizationStructure } from './index';
import { useInternationalContext } from '@repo/gatsby-localization-helpers';

export const useUiComponentsInternationalContext = () => {
  return useInternationalContext(uiComponentsLocalizationStructure);
};
